import { createSlice } from '@reduxjs/toolkit';

const emptyStats = {
  totalClaims: 0,
  todayClaims: 0,
  thisMonthClaims: 0,
  uniqueFarmers: 0,
  /** Optional: from API — max claims for any farmer (for slider upper bound) */
  maxClaims: 0,
};

const initialState = {
  claimsStatsLoading: false,
  claimsStats: { ...emptyStats },
  claimsFarmers: [],
  claimsFarmersTotal: 0,
  claimsStatsListQuery: { page: 1, limit: 20 },
  claimsDetailLoading: false,
  claimsDetailList: [],
  /** Mobile used for last GET /claims/:mobile (refetch after bulk action) */
  claimsDetailMobile: null,
  claimsBulkActionLoading: false,
  /** '1' = allow approve/reject; '0' = hide actions */
  claimApprovalStatus: '0',
  claimApprovalStatusLoading: false,
  claimApprovalStatusUpdating: false,
};

const claimsSlice = createSlice({
  name: 'claims',
  initialState,
  reducers: {
    startClaimsStatsLoading(state) {
      state.claimsStatsLoading = true;
    },
    setClaimsStatsSuccess(state, action) {
      state.claimsStatsLoading = false;
      const payload = action.payload || {};
      state.claimsStats = { ...emptyStats, ...payload.stats };
      state.claimsFarmers = Array.isArray(payload.farmers) ? payload.farmers : [];
      const total = Number(payload.totalFarmers);
      state.claimsFarmersTotal = Number.isFinite(total) && total >= 0 ? total : 0;
      const p = Number(payload.page);
      const l = Number(payload.limit);
      state.claimsStatsListQuery = {
        page: Number.isFinite(p) && p > 0 ? p : state.claimsStatsListQuery.page,
        limit: Number.isFinite(l) && l > 0 ? l : state.claimsStatsListQuery.limit,
      };
    },
    failClaimsStats(state) {
      state.claimsStatsLoading = false;
    },
    startClaimsDetailLoading(state) {
      state.claimsDetailLoading = true;
      state.claimsDetailList = [];
      state.claimsDetailMobile = null;
    },
    setClaimsDetailSuccess(state, action) {
      state.claimsDetailLoading = false;
      const p = action.payload;
      if (Array.isArray(p)) {
        state.claimsDetailList = p;
      } else {
        state.claimsDetailList = Array.isArray(p?.list) ? p.list : [];
        state.claimsDetailMobile = p?.mobileNumber ?? null;
      }
    },
    failClaimsDetail(state) {
      state.claimsDetailLoading = false;
    },
    clearClaimsDetail(state) {
      state.claimsDetailList = [];
      state.claimsDetailLoading = false;
      state.claimsDetailMobile = null;
    },
    startClaimsBulkAction(state) {
      state.claimsBulkActionLoading = true;
    },
    stopClaimsBulkAction(state) {
      state.claimsBulkActionLoading = false;
    },
    startClaimApprovalStatusLoading(state) {
      state.claimApprovalStatusLoading = true;
    },
    stopClaimApprovalStatusLoading(state) {
      state.claimApprovalStatusLoading = false;
    },
    startClaimApprovalStatusUpdating(state) {
      state.claimApprovalStatusUpdating = true;
    },
    stopClaimApprovalStatusUpdating(state) {
      state.claimApprovalStatusUpdating = false;
    },
    setClaimApprovalStatus(state, action) {
      const raw = action.payload;
      const s = raw === '1' || raw === 1 ? '1' : '0';
      state.claimApprovalStatus = s;
    },
  },
});

export default claimsSlice.reducer;
export const {
  startClaimsStatsLoading,
  setClaimsStatsSuccess,
  failClaimsStats,
  startClaimsDetailLoading,
  setClaimsDetailSuccess,
  failClaimsDetail,
  clearClaimsDetail,
  startClaimsBulkAction,
  stopClaimsBulkAction,
  startClaimApprovalStatusLoading,
  stopClaimApprovalStatusLoading,
  startClaimApprovalStatusUpdating,
  stopClaimApprovalStatusUpdating,
  setClaimApprovalStatus,
} = claimsSlice.actions;
